var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHorse = function SvgIconHorse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12 2a10 10 0 0 1 10 10.145c-.073 5.368-4.435 9.75-9.801 9.855a9.96 9.96 0 0 1-6.867-2.543 1 1 0 1 1 1.336-1.489 8 8 0 0 0 1.69 1.161l2.15-3.01c-1.938-.787-4.01-.663-5.344-.442a3.24 3.24 0 0 1-3.182-1.302l-1.293-1.79a1 1 0 0 1 .287-1.437l9.274-5.707V3a1 1 0 0 1 1-1zm-1.682 17.826c.6.128 1.216.188 1.838.174h.003c4.29-.083 7.783-3.594 7.841-7.882A8 8 0 0 0 15.09 4.62a8 8 0 0 0-2.839-.616V6a1 1 0 0 1-.476.852l-8.833 5.435.665.92a1.24 1.24 0 0 0 1.22.498l.007-.001c1.665-.276 4.685-.483 7.42 1.037A3.5 3.5 0 0 0 15.5 11.25a1 1 0 1 1 2 0 5.5 5.5 0 0 1-4.967 5.474z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconHorse;